import { TAO_KOE, EN_KO } from './../libs';
import Shop from './shop';

class Chip {
	constructor( chipEl, type, filter = false ) {
		this.type = type;
		this.chipEl = chipEl;
		this.filter = filter || this.getFilter();
	}

	getFilterName = () => {
		switch ( this.type ) {
			case 'brands':
				return this.chipEl.dataset.brand;

			case 'themes':
				return this.chipEl.dataset.theme;

			case 'badges':
				return this.chipEl.dataset.badge;

			case 'salenew':
				return this.chipEl.dataset.salenew;

			case 'category':
			default:
				return this.chipEl.dataset.pimid;
		}
	};

	getFilter = () => {
		// Use pre-saved filter or look for the filter in the current filterJSON.
		this.filter = this.filter || this.fetchFilter();
		return this.filter;
	};

	fetchFilter = () => {
		return Shop.getFilter( this.type, this.getFilterName() );
	};

	toggleElement = () => {
		// Get Filter.
		const foundFilter = this.getFilter();

		// No Filter found => Hide me.
		if ( ! foundFilter ) {
			// Hide Parent Element.
			this.chipEl.parentElement.classList.add( 'en_hidden' );
		} else {
			// Linkfield is different, depending on type.
			const fieldName = 'category' === this.type ? 'fullLink' : 'link';

			// Add active class.
			if ( foundFilter && ( foundFilter.current || foundFilter.selected ) ) {
				this.chipEl.classList.add( 'en_is_active' );
			}

			// Update Link, if applicable.
			if ( foundFilter && foundFilter[ fieldName ] ) {
				// Build Shop link.
				this.chipEl.href = Shop.buildShopUrl( foundFilter[ fieldName ] );
			}
		}

		return !! foundFilter;
	};

	static initChip( chipEl, type, filter = false ) {
		// Initialise Chip and toggle immediately.
		chipEl.KOE_AUTO_CHIP ??= new Chip( chipEl, type, filter );
		return chipEl.KOE_AUTO_CHIP;
	}

	static async toggleChipAsync( chipEl, type, filter ) {
		const instance = await Chip.initChip( chipEl, type, filter );
		return instance.toggleElement();
	}
}

// Update custom category chips - Hide unneeded chips.
Chip.initCategoryChips = function() {
	// Check if Listpage.
	const facetEl = document.getElementById( 'offcanvas_facet_filter' );
	if ( ! facetEl ) {
		return false;
	}

	// Check if linklist exist.
	const linkListEls = document.querySelectorAll( '.en_mdl_linklist.en_mdl_linklist--category' );
	if ( linkListEls.length <= 0 ) {
		return false;
	}

	// Load Categories from filterJSON.
	const categories = Shop.getCategoriesFlat() || [];
	// No Filter JSON - No Data.
	if ( 0 === categories.length ) {
		return false;
	}

	linkListEls.forEach( ( linklistEl ) => {
		const wrapperEls = linklistEl.querySelectorAll( '.en_mdl_linklist__wrapper' );
		wrapperEls.forEach( ( wrapperEl ) => {
			// Utility function for slider refresh.
			const bouncer = EN_KO.lodash.debounce( () => wrapperEl.dispatchEvent( new CustomEvent( 'carouselUpdateItems.sl', { bubbles: true } ) ), 250 );
			const refreshSlider = ( isValid ) => isValid || bouncer();

			// Setup default pimid links.
			const pimLinkEls = wrapperEl.querySelectorAll( 'a[data-pimid]' );
			pimLinkEls.forEach( ( linkEl ) => {
				// Check identifier on the Link.
				const identifier = linkEl.getAttribute( 'data-pimid' );
				if ( ! identifier ) {
					return true;
				}

				// Theme Filter > Category Filter.
				const theme = linkEl.getAttribute( 'data-theme' );
				if ( theme ) {
					return true;
				}

				// Init Category Chips - small performanceopt, compared to other filters here, cause of tree-flattening.
				const foundFilter = categories.find( ( filter ) => filter.identifier === identifier );
				Chip.toggleChipAsync( linkEl, 'category', foundFilter ).then( refreshSlider );
			} );

			// Check all brand links.
			wrapperEl.querySelectorAll( 'a[data-brand]' ).forEach( ( linkEl ) => Chip.toggleChipAsync( linkEl, 'brands' ).then( refreshSlider ) );

			// Check all theme links.
			wrapperEl.querySelectorAll( 'a[data-theme]' ).forEach( ( linkEl ) => Chip.toggleChipAsync( linkEl, 'themes' ).then( refreshSlider ) );

			// Check all badge links.
			wrapperEl.querySelectorAll( 'a[data-badge]' ).forEach( ( linkEl ) => Chip.toggleChipAsync( linkEl, 'badges' ).then( refreshSlider ) );

			// Check all salenew links.
			wrapperEl.querySelectorAll( 'a[data-salenew]' ).forEach( ( linkEl ) => Chip.toggleChipAsync( linkEl, 'salenew' ).then( refreshSlider ) );
		} );
	} );

	return true;
};

// Init.
TAO_KOE.ready( 'shop-chips.js', Chip.initCategoryChips );

// Expose.
Shop.Chip = Chip;
export default Chip;
